// Delivery status of an outgoing message only ever moves forward:
// sending → sent → delivered → read. Events arrive out of order (the send ack
// can land after the read receipt, a history refetch can carry an older
// snapshot), so every writer merges with `mergeStatus` instead of assigning —
// otherwise a late 'sent' ack turns blue ticks back to grey.

const STATUS_RANK = {
  failed: -1,
  sending: 0,
  sent: 1,
  delivered: 2,
  read: 3,
  seen: 3,
};

export const statusRank = (status) => STATUS_RANK[status] ?? 0;

export const mergeStatus = (current, incoming) => {
  if (!incoming) return current;
  if (!current) return incoming;
  // A failed bubble can be retried into a real status; nothing goes back to failed
  // except an optimistic 'sending' one.
  if (incoming === 'failed') return current === 'sending' ? 'failed' : current;
  return statusRank(incoming) > statusRank(current) ? incoming : current;
};

/** True for ids the server issued (not optimistic `temp-…` / `sys-…` ones). */
export const isServerMessageId = (id) =>
  id !== undefined && id !== null && /^\d+$/.test(String(id));
